import { MutationTree } from 'vuex'
import { IUserState } from '@/store/user'
import { Types, Store, Current, ScrollTop, Filter } from '@/store/user/types'

const mutations: MutationTree<IUserState> = {
  [Types.store]: (state, action: Store) => {
    state.response = action.payload
  },
  [Types.current]: (state, action: Current) => {
    state.current = action.payload
  },
  [Types.scrollTop]: (state, action: ScrollTop) => {
    state.scrollTop = action.payload
  },
  [Types.filter]: (state, action: Filter) => {
    state.filter = action.payload
  }
}

export default mutations
